"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REMOVE_REPORTS_FAILURE = exports.REMOVE_REPORTS_SUCCESS = exports.REMOVE_REPORTS_REQUEST = void 0;
const namespace_1 = require("./namespace");
exports.REMOVE_REPORTS_REQUEST = (0, namespace_1.namespaced)('REMOVE_REPORTS_REQUEST');
exports.REMOVE_REPORTS_SUCCESS = (0, namespace_1.namespaced)('REMOVE_REPORTS_SUCCESS');
exports.REMOVE_REPORTS_FAILURE = (0, namespace_1.namespaced)('REMOVE_REPORTS_FAILURE');
//# sourceMappingURL=removal.js.map